import * as actionTypes from './actionTypes';
import axios from '../../axios-url';
import { DEFAULT_COMPANY_ID, ENCRYPT, DECRYPT  } from '../../shared/utility';

export const authStart = () =>{
    return{
        type:actionTypes.AUTH_START
    }
}

export const authSuccess = (idToken, userId, hrTeam, admin) =>{
    return{
        type:actionTypes.AUTH_SUCCESS,
        token:idToken,
        userId :userId,
        hrTeam,
        admin
    }
}


export const authFail= (error) =>{
    return{
        type:actionTypes.AUTH_FAIL,
        error:error
    }
}

export const logout = () =>{
    localStorage.clear();
    return{
        type:actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(()=> {
            dispatch(logout());
        }, expirationTime * 1000)
    }
}

export const authHealthCheck = (token) => {
    return dispatch => {
        let url = '/request/api/request/healthcheck';  

        axios.get(url, {
            headers:{
                'Authorization': 'Bearer '+ token
            }
        })
            .then(response =>{
                if(response.status === 200){
                    localStorage.setItem('CompanyId',response.data.CompanyId);
                    localStorage.setItem('EmpId',response.data.EmpId);
                    localStorage.setItem('UserRole',response.data.UserRole);
                    localStorage.setItem('userId',response.data.Login);
                    localStorage.setItem('defaultbranch',response.data.defaultbranch);
                }   
            })
        .catch(err => {
        
        })
    }
}

export const menuStart = () =>{
    return{
        type:actionTypes.MENU_START
    }
}

export const menuSuccess = (list) =>{
    return{
        type:actionTypes.MENU_SUCCESS,
        list:list,
    }
}

export const menuFail= (error) =>{
    return{
        type:actionTypes.MENU_FAIL,
        error:error
    }
}

export const authMobileVerificationStart = (code) => {
    return{
        type:actionTypes.AUTH_MOBILE_VERIFICATION_START,
        code:code
    }
}

export const roleStart = () =>{
    return{
        type:actionTypes.ROLE_START
    }
}

export const roleSuccess = (list) =>{
    return{
        type:actionTypes.ROLE_SUCCESS,
        list:list,
    }
}

export const roleFail= (error) =>{
    return{
        type:actionTypes.ROLE_FAIL,
        error:error
    }
}

export const getRoleAccess = (empID,type) => {
    return dispatch => {
        dispatch(roleStart());
        let url = 'master/api/GetInitialAccess';
        if(type === 'GetAuthorization'){
            url = '/master/api/GetAuthorization?id='+empID;//+empID; //'/master/api/AccessMenu/GetAccessMenu?id='+empID;
        }else if(type === 'GetAccessForRole'){
            url = '/master/api/GetAccessForRole?roleid='+empID;
        }
        axios.get(url)
            .then(response =>{
                if(response.status === 200){
                    let menuItems = response.data;
                    var obj = menuItems;
                    if(menuItems && menuItems.length > 0){
                        obj.sort((a,b) => a.menusequence - b.menusequence);
                        obj.map(item => {
                            let subMenus = item.menuRights;
                            if(subMenus && subMenus.length > 0){
                                subMenus.sort((a,b) => a.submenusequence - b.submenusequence);
                                subMenus.map(subItem => {
                                    return subItem;
                                })
                            }
                            return {...item,menuRights:subMenus};
                        });
                    }
                    dispatch(roleSuccess(obj));
                }   
            })
        .catch(err => {
            dispatch(roleFail('API Fetch Error'));
        })
      
    }
}

export const getMenuAccess = (empID,type) => {
    return dispatch => {
        dispatch(menuStart());
        const menuStorage = localStorage.getItem('menuStorage_'+type);
        if(!menuStorage){
        let url = 'master/api/GetInitialAccess';
        if(type === 'GetAuthorization'){
            url = '/master/api/GetAuthorization?id='+empID;//+empID; //'/master/api/AccessMenu/GetAccessMenu?id='+empID;
        }else if(type === 'GetAccessForRole'){
            url = '/master/api/GetAccessForRole?roleid='+empID;
        }
        axios.get(url)
            .then(response =>{
                if(response.status === 200){
                    let menuItems = response.data;
                    var obj = menuItems;
                    if(menuItems && menuItems.length > 0){
                        obj.sort((a,b) => a.menusequence - b.menusequence);
                        obj.map(item => {
                            let subMenus = item.menuRights;
                            if(subMenus && subMenus.length > 0){
                                subMenus.sort((a,b) => a.submenusequence - b.submenusequence);
                                subMenus.map(subItem => {
                                    return subItem;
                                })
                            }
                            return {...item,menuRights:subMenus};
                        });
                    }
                    if(type === 'GetAuthorization'){
                        localStorage.setItem('menuStorage_'+type,ENCRYPT(JSON.stringify(obj)));
                       // localStorage.setItem('menuStorage_'+type,JSON.stringify(obj));
                    }

                    dispatch(menuSuccess(obj));
                }   
            })
        .catch(err => {
            dispatch(menuFail('API Fetch Error'));
        })
        }else{
            dispatch(menuSuccess(JSON.parse(DECRYPT(menuStorage))));
           // dispatch(menuSuccess(JSON.parse(menuStorage)));
        }
    }
}

export const getUserPosInfo = (data) => {
    return{
        type:actionTypes.USER_POS_INFO,
        data:data
    }
}

export const verifiedOTP = (code) => {
    return dispatch => {
        let retrievedObjectses = sessionStorage.getItem('mobileVerify');
        if(retrievedObjectses){
            let userData = JSON.parse(retrievedObjectses); 
           
            let tokenValue = JSON.parse(userData.tokenValue);
                  
            const setTimeExpiry = 10800;
            const expirationDate = new Date(new Date().getTime() + setTimeExpiry * 1000);
            localStorage.setItem('token',tokenValue.Token);
            localStorage.setItem('expirationDate',expirationDate);

            localStorage.setItem('CompanyId',userData.companyID);
            localStorage.setItem('EmpId',userData.empID);
            localStorage.setItem('UserRole',userData.userRole);
            localStorage.setItem('userId',userData.loginId);
            localStorage.setItem('userName',userData.userName);
            localStorage.setItem('firstTimeLogin',userData.firstTimeLogin);
            localStorage.setItem('userID',userData.userID);
            localStorage.setItem('employeeInfo',ENCRYPT(JSON.stringify(userData)))
            localStorage.setItem('empGroupCode',userData.empGroupCode)

            dispatch(getUserPosInfo(userData));

            dispatch(getUserDetails(userData.userID));
            dispatch(authSuccess(tokenValue.Token,userData.empID));
            //dispatch(getMenuAccess(userData.empID,'GetAuthorization'));
            dispatch(checkAuthTimeout(setTimeExpiry));
            sessionStorage.setItem('mobileVerify','');
        }
    }
}



    export const auth = (empID, password, isSignup,Ar=false, mobile=false ) =>{
   return dispatch => {
       dispatch(authStart());

        // const setTimeExpiry = 6000;
        // const expirationDate = new Date(new Date().getTime() + setTimeExpiry * 1000);
        // localStorage.setItem('token',empID);
        // localStorage.setItem('userId','E984ACD1-CD6B-45BE-8A36-6026C4C9EBA2');
        // localStorage.setItem('EmpId','E984ACD1-CD6B-45BE-8A36-6026C4C9EBA2');
        // localStorage.setItem('CompanyId','A0BA923B-5157-4996-A1DB-6105CD5FE752')
        // localStorage.setItem('expirationDate',expirationDate);
        // dispatch(authSuccess(empID,empID));
        // dispatch(checkAuthTimeout(setTimeExpiry));
        // return;


        let url = '/auth/api/authentication';    
        if(!mobile){
            const userData = {
                UserId : empID,
                Password: password,
                CompanyId : "A0BA923B-5157-4996-A1DB-6105CD5FE752",
                Mobile:false
            }
            
            axios.post(url,userData)
                .then(response =>{
                    if(response.status === 200){
                        
                        
                        let tokenValue = JSON.parse(response.data.tokenValue);
                        const setTimeExpiry = 10800;
                        const expirationDate = new Date(new Date().getTime() + setTimeExpiry * 1000);
                        localStorage.setItem('token',tokenValue.Token);
                        localStorage.setItem('expirationDate',expirationDate);
                        if(response.data.companyID!==null){
                            localStorage.setItem('CompanyId',response.data.companyID);
                        }else{
                            localStorage.setItem('CompanyId',DEFAULT_COMPANY_ID);
                        }
                        // if(Ar == false){
                        //     localStorage.setItem('Lang',"En");
                        // }else{
                        //     localStorage.setItem('Lang',"Ar");
                        // }
                        localStorage.setItem('EmpId',response.data.empID);
                        localStorage.setItem('UserRole',response.data.userRole);
                        localStorage.setItem('userId',response.data.loginId);
                        localStorage.setItem('tooltip',response.data.userName);
                        localStorage.setItem('firstTimeLogin',response.data.firstTimeLogin);
                        localStorage.setItem('hrTeam',response.data.hrTeam ? 1 : 0);
                        localStorage.setItem('admin',response.data.admin ? 1 : 0);
                        localStorage.setItem('employeeInfo',ENCRYPT(JSON.stringify(response.data)))
                        localStorage.setItem('doj',response.data.doj);
                        localStorage.setItem('nationality',response.data.nationality);
                        localStorage.setItem('email',response.data.email);
                        localStorage.setItem('mobile',response.data.mobile);
                        localStorage.setItem('userID',response.data.userID);
                        localStorage.setItem('empGroupCode',response.data.empGroupCode)
                        localStorage.setItem('isEditingWca',false);
                        localStorage.setItem('autoRefresh',false);
                        localStorage.setItem('defaultbranch',response.data.defaultbranch);
                        localStorage.setItem('defaultpage',response.data.defaultpage);

                        dispatch(getUserPosInfo(response.data));
                        dispatch(getUserDetails(response.data.userID));
                        dispatch(authSuccess(tokenValue.Token,response.data.empID, response.data.hrTeam, response.data.admin));
                        //dispatch(getMenuAccess(response.data.empID,'GetAuthorization'));
                        dispatch(checkAuthTimeout(setTimeExpiry));
                    }
                })
                .catch(err => {
                    dispatch(authFail('Invalid username or password'));
                })
        }else{
            const userData = {
                UserId : empID,
                CompanyId : "A0BA923B-5157-4996-A1DB-6105CD5FE752",
                Mobile:true
            }
            
            axios.post(url,userData)
                .then(response =>{ 
                    if(response.status === 200){
                        sessionStorage.setItem('mobileVerify',JSON.stringify(response.data));
                       
                        let randomDigit = 123456;//Math.floor(100000 + Math.random() * 900000);
                        dispatch(authMobileVerificationStart(randomDigit));

                        
                    }
                })
                .catch(err => {
                    dispatch(authFail(empID + ' is not a valid phone number'));
                })
        }

        

   }
}

export const setAuthRedirectPath = (path) =>{
    return{
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem('token');
        if(!token){
            dispatch(logout());
        }else{
            const expirationDate =  new Date(localStorage.getItem('expirationDate'));

            if(expirationDate <= new Date()){
                dispatch(logout());
            }else{
                const userId = localStorage.getItem('userId');
                const EmpId = localStorage.getItem('EmpId');
                const userID = localStorage.getItem('userID');

                let userInfo = localStorage.getItem('employeeInfo');
                if(userInfo !==null){
                    dispatch(getUserPosInfo(JSON.parse(DECRYPT(userInfo))));
                }
                dispatch(getUserDetails(userID));
                dispatch(authSuccess(token, userId));
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
            }
        }
    }
}


export const userDetailsStart = () =>{
    return{
        type:actionTypes.USER_DETAIL_START
    }
}

export const userDetailsSuccess= (data) =>{
    return{
        type:actionTypes.USER_DETAIL_SUCCESS,
        data :data
    }
}

export const userDetailsFail= (error) =>{
    return{
        type:actionTypes.USER_DETAIL_FAIL,
        error:error
    }
}

export const getUserDetails = (userId) => {
    return dispatch => {
        dispatch(userDetailsStart());
        dispatch(getMenuAccess(userId,'GetAuthorization'));
        const userDetails= localStorage.getItem('userDetails_'+userId);
        if(userDetails === null){
            axios.get('/master/api/GeUsers?id='+userId)
            .then(response =>{
                if(response.status === 200){
                    let userDetails = response.data.users;   
                    localStorage.setItem('userDetails_'+userId,ENCRYPT(JSON.stringify(userDetails)));
                    dispatch(getMenuAccess(userId,'GetAuthorization'));
                    dispatch(userDetailsSuccess(userDetails));                    
                }
            })
            .catch(err => {
                dispatch(userDetailsFail('User Detail Api Error'));
            })    
        }
        else{
            dispatch(userDetailsSuccess(JSON.parse(DECRYPT(userDetails))));
            //dispatch(getMenuAccess(JSON.parse(DECRYPT(userDetails)).userId,'GetAuthorization'));
            dispatch(getMenuAccess(userId,'GetAuthorization'));
        }
    }
}

export const setSelectedModule = (module) => {
    return {
        type: actionTypes.SET_SELECTED_MODULE,
        module: module
    }
}